import React from 'react';
import { CheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { images } from '../data/business';
import type { Localized } from '../types';
const points: Localized[] = [{
  en: 'Family-owned and locally operated in Houston',
  es: 'Empresa familiar y local en Houston'
}, {
  en: '10+ years of professional cleaning experience',
  es: 'Más de 10 años de experiencia profesional'
}, {
  en: '500+ satisfied residential customers',
  es: 'Más de 500 clientes residenciales satisfechos'
}, {
  en: 'Bilingual team — English & Spanish',
  es: 'Equipo bilingüe: inglés y español'
}, {
  en: 'Fully licensed, insured and bonded',
  es: 'Con licencia, seguro y fianza'
}, {
  en: 'Eco-friendly, family-safe products',
  es: 'Productos ecológicos y seguros para la familia'
}];
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="bg-white" data-id="element-19" data-mp="3rg130lar59df">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-20" data-mp="3req4azw5yrt6">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-21" data-mp="2lssb3qkvley6">
          <div data-id="element-22" data-mp="2gr2xq4a6kp6x">
            <p className="font-display text-sm font-bold text-bright" data-id="element-23" data-mp="2gqkuuot0jcq1">{t(copy.aboutKicker)}</p>
            <h2 className="mt-2 font-display text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-24" data-mp="2crc47st9ruyp">
              {t(copy.aboutTitle)}
            </h2>
            <p className="mt-5 text-base leading-relaxed text-charcoal/70" data-id="element-25" data-mp="34hynywyzncc2">{t(copy.aboutBody)}</p>

            <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-26" data-mp="30fvak2srdxo5">
              {points.map(point => <li key={point.en} className="flex items-start gap-2.5" data-id="element-27" data-mp="2vodadgyk8148">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-bright" aria-hidden="true" data-id="element-28" data-mp="2qqtw4h1v3oca" />
                  <span className="text-sm text-charcoal/80" data-id="element-29" data-mp="3o67q9zu8wypa">{t(point)}</span>
                </li>)}
            </ul>
          </div>

          <div className="overflow-hidden rounded-3xl shadow-lift" data-id="element-30" data-mp="3jdocp2vk63kh">
            <img src={images.team} alt={t(copy.aboutImageAlt)} className="block w-full object-cover" data-id="element-31" data-mp="66vbqunj9h2e" />
          </div>
        </div>
      </div>
    </section>;
}